import React from "react";
import yizugou from "./yizugou.jpg";
class EasyRentGo extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {};
  }

  render() {
    return (
      <div
        className="noSorrowBox"
        style={{ minHeight: "100vh", background: "#f3f4f5" }}
      >
        <img src={yizugou} style={{ width: "100%" }} />
      </div>
    );
  }
}
export default EasyRentGo;



// WEBPACK FOOTER //
// ./src/easyrentgo/index/index.js